package com.karyadina.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

@Composable
actual fun rememberCameraPermissionLauncher(
    onResult: (Boolean) -> Unit
): CameraPermissionLauncher {
    return remember {
        object : CameraPermissionLauncher {
            override fun launch() {
                // Browser handles permission via API call usually, or we just allow it
                onResult(true) 
            }
        }
    }
}
